import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import i18next from "i18next";
import { formatNumber } from "_common/utils/formatValue";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { useQuery } from "@tanstack/react-query";
import { PriceApi } from "states/api/price";
import classNames from "classnames";
import Crypto from "./Crypto";
import Stock from "./Stock";
import Forex from "./Forex";

const MarketPage = observer(() => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const {
    authStore: { banners, top_coin, games },
  } = useStores();

  const [active, setActive] = useState("stock");

  return (
    <div className="home-page market-page">
      <HeaderTop title={i18next.t("market")} isBack={false} />
      <div className="tabs tab-head">
        <div
          className={classNames("tab", { active: active === "stock" })}
          onClick={() => setActive("stock")}
        >
          Chứng khoán
        </div>
        <div
          className={classNames("tab", { active: active === "coin" })}
          onClick={() => setActive("coin")}
        >
          Crypto
        </div>
        <div
          className={classNames("tab", { active: active === "forex" })}
          onClick={() => setActive("forex")}
        >
          Kim Loại
        </div>
      </div>
      {active === "coin" && <Crypto />}
      {active === "stock" && <Stock />}
      {active === "forex" && <Forex />}
    </div>
  );
});

export default MarketPage;
